import * as React from 'react';
import { MessageDescriptor } from 'react-intl';
import { intl } from 'i18n';

interface Props {
    bodyMessage: MessageDescriptor;
    bodyMessageValues?: any;
    link?: string;
    linkMessage?: MessageDescriptor;
}

export const WarningBox: React.FunctionComponent<Props> = (props) => {
    return (
        <div className='warning-box'>
            <div className='warning-icon'></div>
            <div className='warning-text'>
                {intl.formatMessage(props.bodyMessage, props.bodyMessageValues)}
                { props.link && props.linkMessage &&
                    <a className='warning-link' href={props.link}>
                        {intl.formatMessage(props.linkMessage)}
                    </a>
                }
            </div>
        </div>
    );
};